import type { ResourceTimingsConfig } from '@atlaskit/react-ufo/resource-timing/types';

export const resourceTimingsConfig: ResourceTimingsConfig = {
	sanitiseEndpoints: (url: string) => url,
	mapResources: (url: string) => url,
	hasTimingHeaders: (url: string) => url.includes('graphql'),
};
